export const HELP_CENTER_URL = ' https://servc.notion.site/Orca-Help-Center-1f87caeb905b80b4905bf4d59bcfe9af?source=copy_link';

export const WEBSITE_PROD_ORCA_SOFTWARE = 'https://www.orcainc.com';
export const WEBSITE_PROD_ORCA = 'https://www.orcainc.com';
export const WEBSITE_PROD_ORCA_PRIVACY_POLICY = 'https://www.orcainc.com/privacy-policy';
export const WEBSITE_PROD_ORCA_TERMS_OF_USE = 'https://www.orcainc.com/terms-of-use';

export const ORCA_HELP_MAIL = 'models@orcainc.com';

export const ERROR_IMAGE_LINK = 'https://servcfilesystem.s3.eu-central-1.amazonaws.com/forDevs/147f3e00-4d65-43f1-83f5-1f10ac484325.jfif';

export const ABOUT_ORCA = 'https://player.vimeo.com/video/1154257952';
export const ABOUT_ORCA_TEXT = 'About ORCA';

export const ABOUT_ORCA_BUDGET_MODEL = 'https://player.vimeo.com/video/1141782238';
export const ABOUT_ORCA_INVESTMENT_MODEL = 'https://player.vimeo.com/video/1139772410';
export const HOW_TO_USE_THIS_MODEL_TEXT = 'How to use this model?';
